module.exports = __webpack_public_path__ + "img/book-journal-whills.ab46850b.svg";